import { mapGetters, mapState } from 'vuex';

export default {
  props: {
    limit: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      tab: null,
    };
  },

  computed: {
    ...mapState('search', ['tabs', 'query', 'currentTab']),

    ...mapGetters('search', ['totalResults']),

    tabResult() {
      return this.tabs[this.tab];
    },

    items() {
      if (!this.tabResult) {
        return [];
      }

      return this.limit !== 0 ? this.tabResult.data.slice(0, this.limit) : this.tabResult.data;
    },

    dataTracking() {
      return window.tracking.getSearchResultsLinkTracking(this.query, this.totalResults, this.tab ?? '');
    },

    isTabActive() {
      return this.currentTab === this.tab;
    },
  },
};
